"use strict";

import {isset} from '../js-utilities';
import ManagerHelper from './helpers/manager-helper';
import {generateValueOutput} from "./helpers/calculator-helpers";

// Lipids
export default class LipidsManager {
    constructor(controller, language) {
        this.controller = controller;
        this.language = language;

        this.$lipidsSummary = $('#lipids_summary');
        this.$lipidsSummaryValue = $('#lipids_summary_value');

        this.$lipidsOutputCellLabel = $('#lipids_output_cell_label');
        this.$lipidsOutputCellValue = $('#lipids_output_cell_value');
        // Icon is not being used but since the functionality works I don't want to remove it, in case we use it again
        this.$lipidsOutputCellIcon = $('#lipids_output_cell_icon');

        this.tgLipidsHelper = new ManagerHelper('lipids_tg', this.controller, this.updateLipidsAgeInfluence.bind(this));
        this.hdlcLipidsHelper = new ManagerHelper('lipids_hdlc', this.controller, this.updateLipidsAgeInfluence.bind(this));
        this.ldlcLipidsHelper = new ManagerHelper('lipids_ldlc', this.controller, this.updateLipidsAgeInfluence.bind(this));
    }

    reconfigureLipidInputs() {
        if (this.tgLipidsHelper) {
            this.tgLipidsHelper.configureInput();
        }
        if (this.hdlcLipidsHelper) {
            this.hdlcLipidsHelper.configureInput();
        }
        if (this.ldlcLipidsHelper) {
            this.ldlcLipidsHelper.configureInput();
        }
    }

    callGenerateSliderGradients() {
        if (this.tgLipidsHelper) {
            this.tgLipidsHelper.callGenerateSliderGradient();
        }
        if (this.hdlcLipidsHelper) {
            this.hdlcLipidsHelper.callGenerateSliderGradient();
        }
        if (this.ldlcLipidsHelper) {
            this.ldlcLipidsHelper.callGenerateSliderGradient();
        }
    }

    // Would like to make this a generic method in the manager helper, but there's still enough deviation that this is simpler
    updateLipidsAgeInfluence(lipids_tg = this.controller.current_values.lipids_tg, lipids_hdlc = this.controller.current_values.lipids_hdlc) {
        this.callGenerateSliderGradients();
        if (isset(lipids_tg) && isset(lipids_hdlc)) {
            const response = this.controller.calculator_4.ageChangeForLipids(lipids_tg, lipids_hdlc, 'si');
            this.populateLipidsOutput(response);
        } else {
            this.populateLipidsOutput();
        }
    }

    // Would like to make this a generic method in the manager helper, but there's still enough deviation that this is simpler
    populateLipidsOutput(response) {
        const lipidsTgOutput = generateValueOutput('lipids_tg', response, this.controller);
        const lipidsHdlcOutput = generateValueOutput('lipids_hdlc', response, this.controller);
        const lipidsLdlcOutput = generateValueOutput('lipids_ldlc', response, this.controller);

        this.controller.current_age_changes.lipids = lipidsTgOutput.ageChange;
        this.controller.current_values.lipids_change = lipidsTgOutput.ageChangeText

        // CAR-220 there is only one "lipids" change value on age_change and current_values
        // this.controller.current_age_changes.lipids_tg = lipidsTgOutput.ageChange;
        // this.controller.current_values.lipids_tg_change = lipidsTgOutput.ageChangeText

        // this.controller.current_age_changes.lipids_hdlc = lipidsHdlcOutput.ageChange;
        // this.controller.current_values.lipids_hdlc_change = lipidsHdlcOutput.ageChangeText

        // this.controller.current_age_changes.lipids_ldlc = lipidsLdlcOutput.ageChange;
        // this.controller.current_values.lipids_ldlc_change = lipidsLdlcOutput.ageChangeText

        const summaryValue = `${lipidsTgOutput.summaryValue}<br>${lipidsHdlcOutput.summaryValue}<br>${lipidsLdlcOutput.summaryValue}`;
        const outputCellLabel = `${lipidsTgOutput.outputCellLabel}<br>${lipidsHdlcOutput.outputCellLabel}<br>${lipidsLdlcOutput.outputCellLabel}`;

        this.$lipidsSummary.html(lipidsTgOutput.summary);
        this.$lipidsSummaryValue.html(summaryValue);

        this.$lipidsOutputCellLabel.html(outputCellLabel);
        this.$lipidsOutputCellValue.html(lipidsTgOutput.outputCellValue).css('color', lipidsTgOutput.outputCellColor);
        // Icon is not being used but since the functionality works I don't want to remove it, in case we use it again
        this.$lipidsOutputCellIcon.prop('src', lipidsTgOutput.outputCellIcon);

        this.controller.calculate_vascular_age();
    }

    // public method for controller to enable and disable UI controls
    enableControls(enable) {
        this.tgLipidsHelper.enableControls(enable);
        this.hdlcLipidsHelper.enableControls(enable);
        this.ldlcLipidsHelper.enableControls(enable);
    }

}
